import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FloatingDonateTag = () => {
  const [top, setTop] = useState(window.innerHeight - (window.innerHeight / 4) - 50); // centered initially
  const dragging = useRef(false);
  const wasDragged = useRef(false);
  const offset = useRef(0);
  const tagRef = useRef(null);

  const onMouseDown = (e) => {
    e.preventDefault();
    dragging.current = true;
    wasDragged.current = false;
    offset.current = e.clientY - top;
    document.body.style.userSelect = 'none';
  };

  const onMouseMove = (e) => {
    if (!dragging.current) return;
    const newTop = e.clientY - offset.current;
    setTop(Math.max(0, Math.min(window.innerHeight - 100, newTop)));

    wasDragged.current = true; // mark as drag
  };

  const onClick = (e) => {
    if (wasDragged.current) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const onMouseUp = () => {
    dragging.current = false;
    document.body.style.userSelect = '';
  };

  useEffect(() => {
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
    return () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, []);

  useEffect(() => {
    const el = tagRef.current;
    if (!el) return;

    const onTouchStart = (e) => {
      if (e.touches.length !== 1) return;
      dragging.current = true;
      wasDragged.current = false;
      offset.current = e.touches[0].clientY - top;
      document.body.style.userSelect = 'none';
      e.stopPropagation(); // Prevent bubbling
    };

    const onTouchMove = (e) => {
      if (!dragging.current || e.touches.length !== 1) return;
      const newTop = e.touches[0].clientY - offset.current;
      setTop(Math.max(0, Math.min(window.innerHeight - 100, newTop)));
      wasDragged.current = true;
      e.preventDefault(); // Prevent scroll
      e.stopPropagation();
    };

    const onTouchEnd = () => {
      dragging.current = false;
      document.body.style.userSelect = '';
    };

    el.addEventListener('touchstart', onTouchStart, { passive: false });
    el.addEventListener('touchmove', onTouchMove, { passive: false });
    el.addEventListener('touchend', onTouchEnd);

    return () => {
      el.removeEventListener('touchstart', onTouchStart);
      el.removeEventListener('touchmove', onTouchMove);
      el.removeEventListener('touchend', onTouchEnd);
    };
  }, [top]);

  const location = useLocation();

  if (location.pathname === '/support-seagull') {
    return null; // Don't show on this route
  }

  return (
    <a
      ref={tagRef}
      href="/support-seagull"
      rel="noopener noreferrer"
      onMouseDown={onMouseDown}
      onClick={onClick}
      onTouchStart={(e) => e.preventDefault()}
      draggable="false"
      style={{
        position: 'fixed',
        right: 0,
        top: `${top}px`,
        zIndex: 9999,
        backgroundColor: '#F57224',
        color: 'white',
        textDecoration: 'none',
        fontWeight: 'bold',
        fontSize: 12,
        borderRadius: '8px 0 0 8px',
        cursor: 'grab',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'auto',
        padding: '8px 6px',
        writingMode: 'vertical-rl',
        transform: 'rotate(0deg)', // keep the tag upright
      }}
    >
      <div
        style={{
          transform: 'rotate(-180deg)',
          transformOrigin: 'center',
          display: 'flex',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <i
          className="fas fa-heart"
          style={{
            transform: 'rotate(90deg)',
            transformOrigin: 'center',
            fontSize: 14,
            color: 'white',
          }}
        />
        <span style={{ fontWeight: 700 }}>Support GLOS</span>
      </div>
    </a>
  );
};

export default FloatingDonateTag;
